import { Buffer } from 'buffer';
import * as process from 'process';

window.process = process; // process polyfill
window.Buffer = Buffer; // buffer polyfill
